import React, { useState } from 'react';
import AdminRolesComponent from './AdminRolesComponent';
import AdminUsersComponent from './AdminUsersComponent';

const tabs = ['Manage Roles', 'Manage Users', 'Manage Publishers'];

const AdminComponent = () => {
  const [activeTab, setActiveTab] = useState(0);

  return (
    <div className="w-full max-w-10xl mx-auto p-4 bg-white mt-4 w-full shadow-md">
      {/* Tab Headers */}
      <div className="flex border-b border-gray-300">
        {tabs.map((tab, index) => (
          <button
            key={tab}
            onClick={() => setActiveTab(index)}
            className={`px-4 py-2 text-sm font-medium transition-colors duration-200 ${
              activeTab === index
                ? 'border-b-2 border-blue-600 text-blue-600'
                : 'text-gray-500 hover:text-blue-500'
            }`}
          >
            {tab}
          </button>
        ))}
      </div>

      <div className="mt-6">
        {activeTab === 0 && <AdminRolesComponent/>}
        {activeTab === 1 && <AdminUsersComponent/>}

        {activeTab === 2 && (
          <section>
            <h2 className="text-xl font-semibold mb-2">Manage Publishers</h2>
            <p className="text-gray-600">Verify publishers and manage their content access.</p>
          </section>
        )}
      
      </div>
    </div>
  );
};

export default AdminComponent;
